Vendd.Scripts.load(function () {
 
    if ($('.x-off-canvas-menu').length <= 0)
        return;

    if (isTouch()) {
        $(window).resize(function () {
            attachToCanvasMenu();
        });
    }

    var isMoved = false;

    if ($(window).outerWidth() < 1200) {
        if (isTouch()) {
            if ($('.x-currency-selector').length > 0)
                $('.x-currency-selector').detach().prependTo('.js-canvas-menu').show();
            $('.x-shortcut').detach().prependTo('.x-secondary-menu').show();
            $('.x-top-menu').detach().prependTo('.x-secondary-menu').show();
            $('.js-main-menu').detach().prependTo('.js-canvas-menu').show();
            $('.x-call-me-back-widget').detach().prependTo('.x-responsive-bottom-menu').show();
            $('.x-wishlist-widget').detach().prependTo('.x-responsive-bottom-menu').show();
            $('.header-region .x-language-selector').detach().prependTo('.x-responsive-bottom-menu').show();

            isMoved = true;
        }
    }

    function attachToCanvasMenu() {

        if ($(window).outerWidth() < 1200) {
            if (!isMoved) {
                if ($('.x-currency-selector').length > 0)
                    $('.x-currency-selector').detach().prependTo('.js-canvas-menu').show();
                $('.x-shortcut').detach().prependTo('.x-secondary-menu').show();
                $('.x-top-menu').detach().prependTo('.x-secondary-menu').show();
                $('.js-main-menu').detach().prependTo('.js-canvas-menu').show();
                $('.x-call-me-back-widget').detach().prependTo('.x-responsive-bottom-menu').show();
                $('.x-wishlist-widget').detach().prependTo('.x-responsive-bottom-menu').show();
                $('.header-region .x-language-selector').detach().prependTo('.x-responsive-bottom-menu').show();

                isMoved = true;
            }
        } else {
            if (isMoved) {
                $('.js-main-menu').detach().insertAfter('.x-sitelogo');
                $('.off-canvas-menu .x-language-selector').detach().insertAfter('.x-menu.main-menu');
                $('.x-top-menu').detach().prependTo('.region-area-five');
                $('.x-shortcut').detach().insertAfter('.x-menu.main-menu');
                if ($('.x-currency-selector').length > 0)
                    $('.x-currency-selector').detach().insertAfter('.x-menu.main-menu');
                $('.x-call-me-back-widget').detach().insertAfter('.x-menu.main-menu');
                $('.x-wishlist-widget').detach().insertAfter('.x-menu.main-menu');

                isMoved = false;
            }
        }
    }

});
